module.exports = __webpack_public_path__ + "media/images/icons/flags/CL-5979be78c513e5925d1a28b82fd03adc.svg";